import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramByFarmId, getCarbonProgramByFarmIdAdmin } from "services";

import { getEnvironment, getLocalKlimVar, useUserContext } from "utils";

import { GET_CARBON_PROGRAM_BY_FARM_ID } from "consts";

import { CarbonProgram } from "models";

export const useGetCarbonProgramByFarmId = (farmId?: string) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const token = getLocalKlimVar("token");

  return useQuery<CarbonProgram>({
    queryKey: [GET_CARBON_PROGRAM_BY_FARM_ID, farmId, isAdmin],
    queryFn: () => (isAdmin ? getCarbonProgramByFarmIdAdmin(farmId ?? "") : getCarbonProgramByFarmId(farmId ?? "")),
    enabled: !!farmId && farmId !== "" && (isAdmin ? true : !!user) && !!token,
  });
};
